import { GET_SERVICE_RESTART_ERROR_CODES, GET_SERVICE_RESTART_LOGS } from "./actionTypes";

export const getServiceRestartErrorCodesInit = () => ({
  type: GET_SERVICE_RESTART_ERROR_CODES.INIT,
});

export const getEpeErrorCodesSuccess = (errorCodeList) => ({
  type: GET_SERVICE_RESTART_ERROR_CODES.SUCCESS,
  payload: errorCodeList,
});

export const getEpeErrorCodesFailure = (errorMessage) => ({
  type: GET_SERVICE_RESTART_ERROR_CODES.ERROR,
  payload: errorMessage,
});

export const getServiceRestartLogsInit = (errorCodes, startDate, endDate, offset) => ({
  type: GET_SERVICE_RESTART_LOGS.INIT,
  errorCodes,
  startDate,
  endDate,
  offset,
});

export const getEpeLogsSuccess = (epeLogs) => ({
  type: GET_SERVICE_RESTART_LOGS.SUCCESS,
  payload: epeLogs,
});

export const getEpeLogsFailure = (errorMessage) => ({
  type: GET_SERVICE_RESTART_LOGS.ERROR,
  payload: errorMessage,
});
